import { type ReactNode, type ReactPortal, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export type PortalToRootProps = {
  children: ReactNode;
};

export const PortalToRoot = (props: PortalToRootProps): ReactPortal => {
  const [container] = useState(() => {
    const el = document.createElement('div');
    document.body.appendChild(el);
    return el;
  });

  useEffect(
    () => () => {
      document.body.removeChild(container);
    },
    [container],
  );

  return createPortal(props.children, container);
};
